import React, { useEffect, useState } from 'react';
import {
  Table,
  TableCell,
  TableRow,
  Collapse,
  Chip,
  Button,
  IconButton,
  makeStyles,
  Box,
  List,
  Typography,
  ListItem,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { getDateinDesiredFormat } from '../../../../@jumbo/utils/dateHelper';
import { Call, Email } from '@material-ui/icons';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import moment from 'moment';
import styles from '../../../../styles/loadboard.module.scss';
import { getTimeDiff } from '@jumbo/utils/commonHelper';
import Popper from '@material-ui/core/Popper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useLocation } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { getAdminUserByAdminId } from 'redux/actions/Users';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.common.dark,
  },
  chipRoot: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 12,
    height: 26,
    fontSize: 14,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  root: {
    width: 500,
  },
}));

const LoadListRow = ({
  row,
  permissions,
  onLoadBook,
  onCall,
  onBid,
  currentLoadFilter,
  onCallRequested,
  onCallRejected,
  key,
  confirmedRequest,
  rejectedRequest,
  userInterestsDrawerOpen,
  active,
  itemIndex
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  // console.log(currentLoadFilter, 'currentLoadFilter');

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setCurrentIndex(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const location = useLocation();
  const adminUser = useSelector(state => state.users.adminUser);
  const [user, setUser] = useState({})

  const showLastContactedBy = () => {
    if(location.pathname == '/workbook/requests' && row.admin_id){
      if(adminUser && adminUser[row.admin_id]) {
        setUser(adminUser[row.admin_id])
      }
      else {
        dispatch(getAdminUserByAdminId(row.admin_id))
      }
    }
  }

  useEffect(() => {
    if(location.pathname == '/workbook/requests' && row.admin_id){
      if(adminUser && adminUser[row.admin_id]) {
        setUser(adminUser[row.admin_id])
      }
    }
  },[adminUser])

  console.log(adminUser)

  return (
    <React.Fragment>
      <TableRow
        className={styles.dailyLoadsTableHeader} /* styles.inProgressRow class to be added when user clicks on send */
        hover
        tabIndex={-1}
        key={row.id}
        onClick={() => {
          setOpen(!open);
          showLastContactedBy()
        }}
        style={{
          cursor: 'pointer',
          borderBottom: `${open ? '1px solid transparent' : ''}`,
          background: `${open ? '#fafafa' : ''}`,
        }}>
        {/* <TableCell style={{ color: '#2868B2' }}>{row.source}</TableCell> */}
        {location.pathname == '/workbook/bookings' ? (
          <React.Fragment>
            <TableCell>{row.type ? `${row.type} ` : '-'}</TableCell>
            {row.source != 'LoadBoard123' ? (
              <TableCell> {row.external_load_id ? `#${row.external_load_id}` : '-'}</TableCell>
            ) : (
              '-'
            )}
            <TableCell>
              {row.owner_operator?.name ? `${row.owner_operator?.name} ` : '-'}
              <span>{row.owner_operator?.phone ? `${row.owner_operator?.phone} ` : '-'}</span>
            </TableCell>
            <TableCell>
              {row.driver?.name ? `${row.driver?.name} ` : '-'}
              <span>{row.driver?.phone ? `${row.driver?.phone} ` : '-'}</span>
            </TableCell>
          </React.Fragment>
        ) : (
          ''
        )}
        {location.pathname != '/workbook/bookings' && location.pathname != "/loads/loadboard" ? <TableCell>{row?.users?.length ? getTimeDiff(row.users[0].created_at) : row?.request_created_at ? getTimeDiff(row.request_created_at) : '-' }</TableCell> : ''}
        <TableCell>
          {row.origin?.name} <br />
          {
             location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests'?
             ''
             :
             <span
            style={{
              fontSize: '12px',
              color:
                currentLoadFilter && currentLoadFilter.dho && parseInt(currentLoadFilter.dho) < parseInt(row.distance_origin)
                  ? 'red'
                  : 'black',
            }}>
            {row.distance_origin && row.distance_origin != '0' ? `Dh-O : ${row.distance_origin}mi` : 'Dh-O : --'}
          </span>
          }
        </TableCell>
        <TableCell>
          {row.destination?.name} <br />
          {
            location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests' ?
            ''
            :
            <span
            style={{
              fontSize: '12px',
              color:
                currentLoadFilter &&
                currentLoadFilter.dhd &&
                parseInt(currentLoadFilter.dhd) < parseInt(row.distance_destination)
                  ? 'red'
                  : 'black',
            }}>
            {row.distance_destination && row.distance_destination != '0'
              ? `Dh-D : ${row.distance_destination}mi`
              : 'Dh-D : --'}
          </span>
          }
        </TableCell>
        {/* <TableCell>{row.distance_destination != '0' ? `${row.distance_destination}mi` : '-'} </TableCell> */}
        <TableCell>{getDateinDesiredFormat(row.pick_up_date, 'MM/DD')}</TableCell>
        {location.pathname != '/workbook/bookings' && location.pathname != '/workbook/requests'? (
          <TableCell>{row.created_at ? `${getTimeDiff(row.row_created_at)} ` : ''}</TableCell>
        ) : (
          ''
        )}
        {/* <TableCell>{row.rate_per_mile != '0' ? `$${row.rate_per_mile}` : '-'}</TableCell> */}
        {location.pathname != '/workbook/requests' ? (
          <TableCell>
            {row.length || row.weight || row.trailer_type ? `${row.trailer_type}` : ' -'}
            {row.length ? `, ${row.length} ft` : ' '}
            {row.weight ? `, ${row.weight}  lbs` : ' '}
          </TableCell>
        ) : (
          ''
        )}
        {location.pathname == '/loads/user-interests' ||  active == 'Ongoing' || active == 'Rejected' || active == 'Failed'  ? (
          <TableCell>
            {/* <Tooltip title="000005525" placement="top-start" className={classes.root}>
                Sharanya
              </Tooltip> */}
            {row.users?.length ? (
              <p className={styles.interestedUserInfo}>
                <Tooltip title={row.users[0].phone || '-'} placement="top-start" className={classes.root} arrow>
                  <span>{row.users[0].name || 'Admin'}</span>
                </Tooltip>
                {/* {row.users[0].name || '-'} */}
                {row.users.length > 1 ? (
                  <span
                    className={styles.count}
                    onClick={e => {
                      e.stopPropagation();
                      userInterestsDrawerOpen(row);
                    }}>{`+${row.users.length - 1}`}</span>
                ) : (
                  ''
                )}
              </p>
            ) : (
              'Admin'
            )}
          </TableCell>
        ) : (
          ''
        )}
        {active == 'Confirmed' ? (
          <TableCell>
            {row?.assigned_name ? 
              <Tooltip title={row?.assigned_phone || '-'} placement="top-start" className={classes.root} arrow>
                  <span>{row?.assigned_name}</span>
              </Tooltip>
            :
              '-'
            }
          </TableCell>
        ) : (
          ''
        )}
        <TableCell>
          {Number(row.rate) != '0' && row.rate != "null" && row.rate != " " ? `$${Number(row.rate)}` : '-'} <br />
          <span style={{ fontSize: '12px', textTransform: 'lowercase' }}>
            {row.rate_per_mile != '0' ? `$${row.rate_per_mile}/mi` : ''}
          </span>
        </TableCell>
        {location.pathname != '/workbook/bookings' ? (
          <TableCell>{row.company_phone ? row.company_phone : '-'}</TableCell>
        ) : (
          ''
        )}
        {/* <TableCell>{row.rate_per_mile != '0' ? `$${row.rate_per_mile}` : '-'}</TableCell> */}
        {/* <TableCell>{row.full_trailer_types}</TableCell> */}
        {/* {location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests' ? (
          <React.Fragment>
            <TableCell>{row.last_contacted_by ? `${row.last_contacted_by} ` : '-'}</TableCell>
            <TableCell>{row.interests_sent_by ? `${row.interests_sent_by} ` : '-'}</TableCell>
          </React.Fragment>
        ) : (
          ''
        )} */}
        {/* {location.pathname == '/workbook/requests' || location.pathname == '/workbook/bookings' ? (
          ''
        ) : (
          <TableCell>
            {row.company_phone ? (
              <span
                className={styles.moreIcon}
                aria-haspopup="true"
                aria-controls={'simple-menu-' + key}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleClick(e, key);
                }}>
                {row.company_phone}
                <ArrowDropDownIcon style={{ position: 'relative', top: '7px' }} />
                <Menu
                  id={'simple-menu-' + key}
                  anchorEl={anchorEl}
                  keepMounted
                  open={currentIndex == key && Boolean(anchorEl) ? true : false}
                  onClose={e => {
                    setAnchorEl(null);
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  className="moreMenu">
                  <MenuItem
                    onClick={() => {
                      onCallRequested(key);
                      handleClose();
                    }}>
                    <span className="supportText">Move to Requested</span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      onCallRejected(key);
                      handleClose();
                    }}
                    className="deleteMenuItem">
                    <span className="supportText" style={{ color: '#c55656' }}>
                      Move to Rejected
                    </span>
                  </MenuItem>
                </Menu>
              </span>
            ) : (
              '-'
            )}
          </TableCell>
        )} */}
        {/* <TableCell>
          <Chip className={classes.chipRoot} label={row.full_partial} />
        </TableCell> */}

        {(permissions.all && location.pathname != '/workbook/bookings') || (permissions &&
          (permissions.loads &&
          (permissions.loads.loadboard &&
          permissions.loads.loadboard.actions.includes('BookBid')) ||  
          (permissions?.loads?.user_interests &&
          permissions?.loads?.user_interests?.actions.includes('BookBid'))) || 
          (permissions.workbook && permissions.workbook.requests && permissions.workbook.requests.actions.includes("MarkConfirmedRejected")))
          ? (
          <TableCell
            align="center"
            style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
            onClick={event => event.stopPropagation()}>
            {/* <CmtDropdownMenu items={userActions} onItemClick={onUserMenuClick} TriggerComponent={<MoreHoriz />} /> */}
            <React.Fragment>
              {row.is_book_allowed && active != 'Rejected' && active != 'Failed' ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    onLoadBook(row);
                  }}>
                  Book
                </Button>
              ) : null}
              {!row.is_book_allowed && active != 'Confirmed' && active != 'Rejected' && active != 'Failed' ? (
                <span
                  className={styles.moreIcon}
                  aria-haspopup="true"
                  aria-controls={'simple-menu-' +itemIndex}
                  style={{ paddingRight: '8px', color: '#2867b2' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleClick(e, itemIndex);
                  }}>
                  {/* {row.company_phone} */}
                  <span>Mark</span>
                  <ArrowDropDownIcon style={{ position: 'relative', top: '8px', left: '-4px', color: '#2867b2' }} />
                  <Menu
                    id={'simple-menu-' + itemIndex}
                    anchorEl={anchorEl}
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    keepMounted
                    open={
                      currentIndex == itemIndex && Boolean(anchorEl)
                        ? true
                        : false
                    }
                    onClose={(e) => {
                      setAnchorEl(null);
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    className="moreMenu">
                    {/* <MenuItem
                      onClick={() => {
                        handleClose();
                      }}>
                      <span className="supportText">Assign to me</span>
                    </MenuItem> */}
                    {location.pathname == '/workbook/requests' ? (
                      <MenuItem
                        onClick={(e) => {
                          setAnchorEl(null);
                          e.preventDefault();
                          e.stopPropagation();
                          onCallRequested(row);
                        }}>
                        <span className="supportText">Move to Confirmed</span>
                      </MenuItem>
                    ) : (
                      <MenuItem
                        onClick={(e) => {
                          setAnchorEl(null);
                          e.preventDefault();
                          e.stopPropagation();
                          onCallRequested(row);
                        }}>
                        <span className="supportText">Move to In Progress</span>
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={(e) => {
                        setAnchorEl(null);
                        e.preventDefault();
                        e.stopPropagation();
                        onCallRejected(row);
                      }}
                      className="deleteMenuItem">
                      <span className="supportText" style={{ color: '#c55656' }}>
                        Move to Rejected
                      </span>
                    </MenuItem>
                  </Menu>
                </span>
              ) : (
                ''
              )}
              {row.is_bid_allowed && active != 'Rejected' && active != 'Failed' ? (
                <React.Fragment>
                  {row.bid_amount ? (
                    <span
                      className={styles.prevBidRate}
                      style={{
                        color: '#666',
                        padding: ' 2px 12px 2px 16px',
                        fontSize: '12px',
                        borderLeft: '1px solid #ddd',
                      }}>
                      Prev: ${row.bid_amount}
                    </span>
                  ) : (
                    ''
                  )}
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      onBid(row);
                    }}>
                    Bid
                  </Button>
                </React.Fragment>
              ) : null}
              {/* {!row.is_bid_allowed && !row.is_book_allowed && row.company_phone ? (
                <Call
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    onCall(row);
                  }}
                />
              ) : null} */}
              {!row.is_bid_allowed && !row.is_book_allowed && row.company_email && active != 'Rejected' ? (
                <a
                  href={`mailto:${row.company_email}`}
                  target="_blank"
                  className="secondaryBtn extraSmallBtn"
                  style={{ width: '100%', color: 'black' }}
                  onClick={() => (window.location = `mailto:${row.company_email}`)}
                  rel="noreferrer">
                  <Email />
                </a>
              ) : null}
            </React.Fragment>
          </TableCell>
        ) : (
          ''
        )}
        {/* {location.pathname == '/workbook/requests' ? (
          <TableCell
            align="center"
            style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
            onClick={event => event.stopPropagation()}>
            <React.Fragment>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  rejectedRequest(row);
                }}>
                Rejected
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  confirmedRequest(row);
                }}>
                Confirmed
              </Button>
            </React.Fragment>
          </TableCell>
        ) : null} */}
        {/* <TableCell>
        ) : (
          ''
        )}
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell> */}
      </TableRow>
      <TableRow className={styles.dailyLoadstableBody}>
        <TableCell style={{ padding: 0, background: `${open ? '#fafafa' : ''}` }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <List className="listInline">
                <ListItem className="listInlineItem">
                  <span>Source:</span>{' '}
                  <span style={{ color: '#2868B2', fontWeight: '400' }}>{row.type != null ? row.source : '-'}</span>
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>Trip:</span> {row.trip_distance != null && row.trip_distance != '0' ? `${row.trip_distance}mi` : '-'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>F/P:</span> {row.full_partial != null ? row.full_partial : '-'}
                </ListItem>
                {/* <ListItem className="listInlineItem">
                  <span>DH-O:</span> {row.distance_origin != null ? row.distance_origin : '-'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>DH-D:</span> {row.distance_destination != null ? row.distance_destination : '-'}
                </ListItem> */}
                {/* <ListItem className="listInlineItem">
                  <span>Rate Per Mile:</span> ${row.rate_per_mile != null ? row.rate_per_mile : '-'}/mi
                </ListItem> */}
                <ListItem className="listInlineItem">
                  <span>Driver Type: </span> {row.driver_type ? row.driver_type : '-'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <p className={styles.emailBlk}>
                    <span> Email: </span>
                    <a className={styles.email} href={`mailto:${row.company_email}`} target="_blank" rel="noreferrer">
                      {row.company_email ? row.company_email : ' -'}
                    </a>
                  </p>
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>PU Time: </span> {row.pick_up_time_start != null ? row.pick_up_time_start : '-'}{' '}
                  {row.pick_up_time_start != null ? row.pick_up_timezone : ''}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>Del Date: </span>{' '}
                  {row.delivery_date_time != null ? getDateinDesiredFormat(row.delivery_date_time, 'MM/DD') : '-'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>Del Time: </span>{' '}
                  {row.delivery_date_time != null ? moment(row.delivery_date_time).format('hh:mm') : '-'}{' '}
                  {row.delivery_date_time != null ? row.delivery_timezone : ''}
                </ListItem>
                {/* <ListItem className="listInlineItem">
                  <span>Phone: </span> {row.company_phone ? row.company_phone : '-'}
                </ListItem> */}
                {/* <ListItem className="listInlineItem">
                  <span>Equipment: </span>
                  {row.trailer_type ? `${row.trailer_type}` : ' -'}
                  {row.length ? `, ${row.length} ft` : ' -'}
                  {row.weight ? `, ${row.weight}  lbs` : ' -'}
                </ListItem> */}
                <ListItem className={styles.commodityy + ' listInlineItem'}>
                  <span>Commodity: </span>
                  {row.commodity ? row.commodity : '-'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>TB reference ID: </span> {row.load_refrence_id ? `${row.load_refrence_id}` : '-'}
                </ListItem>
                {row.source != 'LoadBoard123' && location.pathname != '/workbook/bookings' ? (
                  <ListItem className="listInlineItem">
                    <span>Load Number: </span> {row.unique_load_id ? `${row.unique_load_id}` : '-'}
                  </ListItem>
                ) : (
                  ''
                )}
                {location.pathname == '/workbook/requests' ?
                  <ListItem className={' listInlineItem'}>
                  {user && Object.keys(user).length ? (
                      <React.Fragment>
                        <span> Last Contacted By: </span> {user?.user?.name ? user.user?.name : '-'}
                      </React.Fragment>
                  ) : null}  
                  </ListItem>
                :
                ''}
                {/* <ListItem className="listInlineItem">
                  <span>Equipment: </span>
                  {row.length ? `${row.trailer_type}` : ' -'}
                  {row.length ? `, ${row.length} ft` : ' -'}
                  {row.weight ? `, ${row.weight}  lbs` : ' -'}
                </ListItem> */}
                {/* <ListItem className="listInlineItem">
                  <span>Length: </span> {row.length ? `${row.length} ft` : ' -'}
                </ListItem>
                <ListItem className="listInlineItem">
                  <span>Weight: </span> {row.weight ? `${row.weight}  lbs` : ' -'}
                </ListItem> */}
                {/* <ListItem className={styles.commodity + ' listInlineItem'}>
                  <span>Commodity: </span>
                  {row.commodity ? row.commodity : '-'}
                </ListItem> */}
                <ListItem className={styles.comments + ' listInlineItem'}>
                  <span>Comments: </span>
                  {row.comments ? row.comments : '-'}
                </ListItem>
                {/* <ListItem className="listInlineItem">
                  <span>Load Details: </span>
                  {row.load_details}
                </ListItem> */}
              </List>
              {/* <Table>
                <TableRow>
                  <TableCell style={{minWidth:'100px'}}>F/P: {row.full_partial}</TableCell>
                  <TableCell style={{minWidth:'100px'}}>DH-O: {row.distance_origin}</TableCell>
                  <TableCell style={{minWidth:'100px'}}>DH-D: {row.distance_destination}</TableCell>
                  <TableCell style={{minWidth:'160px'}}>Rate Per Mile: ${row.rate_per_mile}/mi</TableCell>
                  <TableCell style={{minWidth:'160px'}}>
                    PU Time: {row.pick_up_time_start} {row.pick_up_timezone}
                  </TableCell>
                  <TableCell style={{minWidth:'150px'}}>{getDateinDesiredFormat(row.delivery_date_time, 'MM/DD')}</TableCell>
                  <TableCell style={{minWidth:'150px'}}>
                    DO Time: {moment(row.delivery_date_time).format('hh:mm')} {row.delivery_timezone}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Phone: {row.company_phone}</TableCell>
                  <TableCell>Email: {row.company_email}</TableCell>
                  <TableCell>Length: {row.length} ft</TableCell>
                  <TableCell>Weight: {row.weight} lbs</TableCell>
                  <TableCell>Commodity: {row.commodity}</TableCell>
                  <TableCell>Comments: {row.comments}</TableCell>
                  <TableCell>Load Details: {row.load_details}</TableCell>
                </TableRow>
              </Table> */}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default React.memo(LoadListRow);
